import { useState } from "react";
import PrimaryInput from "../../common/form/PrimaryInput";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import SelectSecondaryComponent from "../../common/form/SelectSecondaryComponent";
import { useFormik } from "formik";
import * as yup from "yup";
import { Warn } from "../../common/svg/AllSvg";
import { useTranslation } from "react-i18next";

const Educations = ({ qualificationList, DropdownIndicator, formik, setCreateEdu, editEdu, setEditEdu, eduDate, setEduDate, setResultIdx, results, modes }: any) => {
    const { t } = useTranslation('common');
    const [dateFromErr, setDateFromErr] = useState<boolean>(false)
    const [dateToErr, setDateToErr] = useState<boolean>(false)

    const eduFormik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            institute_name: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.institute_name) ? formik?.values?.educations?.[editEdu]?.institute_name : '',
            specialization_name: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.specialization_name) ? formik?.values?.educations?.[editEdu]?.specialization_name : '',
            board_name: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.board_name) ? formik?.values?.educations?.[editEdu]?.board_name : '',
            standard_id: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.standard_id) ? { label: formik?.values?.educations?.[editEdu]?.standard_name, value: formik?.values?.educations?.[editEdu]?.standard_id } : '',
            start_date: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.start_date) ? formik?.values?.educations?.[editEdu]?.start_date : '',
            end_date: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.end_date) ? formik?.values?.educations?.[editEdu]?.end_date : '',
            per_cgpa: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.per_cgpa) ? formik?.values?.educations?.[editEdu]?.per_cgpa : '',
            result: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.result) ? results?.find((item: any) => formik?.values?.educations?.[editEdu]?.result === item?.value) : '',
            mode: ((!!editEdu || editEdu === 0) && !!formik?.values?.educations?.[editEdu]?.mode) ? modes?.find((item: any) => formik?.values?.educations?.[editEdu]?.mode === item?.value) : '',
        },
        validationSchema: yup.object().shape({
            institute_name: yup.string().required(t("recruitment.profile.err.institute_name")),
            specialization_name: yup.string().required(t("recruitment.profile.err.specialization_name")),
            board_name: yup.string().required(t("recruitment.profile.err.board_name")),
            standard_id: yup.object().required(t("recruitment.profile.err.standard_id")),
            start_date: yup.date().required(t("recruitment.profile.err.start_date")),
            end_date: yup.date().required(t("recruitment.profile.err.end_date")),
            per_cgpa: yup.number().required(t("recruitment.profile.err.per_cgpa")),
            result: yup.object().required(t("recruitment.profile.err.result")),
            mode: yup.object().required(t("recruitment.profile.err.mode")),
        }),
        onSubmit: async (values: any, { resetForm }: any) => {
            //submit
            if (!!editEdu || editEdu === 0) {
                let arr: any[] = [...eduDate]
                arr[editEdu] = { min: values?.start_date, max: values?.end_date }
                setEduDate(arr)
            } else {
                setEduDate([...eduDate, { min: values?.start_date, max: values?.end_date }])
            }

            // if (!!editEdu || editEdu === 0) {
            //     if (values?.result?.value === "failed") {
            //         setResultIdx(editEdu + 1)
            //     }
            // } else {
            //     if (values?.result?.value === "failed") {
            //         setResultIdx(formik?.values?.educations?.length + 1)
            //     }
            // }


            if (!!editEdu || editEdu === 0) {
                let arr: any[] = [...formik?.values?.educations]
                arr[editEdu] = {
                    ...values,
                    standard_id: values?.standard_id?.value,
                    standard_name: values?.standard_id?.label,
                    result: values?.result?.value,
                    mode: values?.mode?.value,
                }
                formik.setFieldValue("educations", arr)
            } else {
                let obj: any = {
                    ...values,
                    standard_id: values?.standard_id?.value,
                    standard_name: values?.standard_id?.label,
                    result: values?.result?.value,
                    mode: values?.mode?.value,
                }
                formik.setFieldValue("educations", [...formik?.values?.educations, obj])
            }
            setCreateEdu(false)
            setEditEdu(null)
            resetForm({ values: '' });
        }
    });

    const handleStartDate = (e: any) => {
        if (eduDate?.length > 0) {
            if ((!!editEdu || editEdu === 0)) {
                let arr: any[] = eduDate?.filter((i: any, idx: number) => idx !== editEdu)

                if (arr?.length > 0) {
                    const isDisabled = arr.some((range: any) =>
                        e.target.value >= range.min && e.target.value <= range.max
                    );

                    if (isDisabled) {
                        eduFormik.setFieldValue("start_date", '')
                        setDateFromErr(true)
                    } else {
                        setDateFromErr(false)
                        eduFormik.setFieldValue("start_date", e.target.value)
                    }
                } else {
                    setDateFromErr(false)
                    eduFormik.setFieldValue("start_date", e.target.value)
                }
            } else {
                const isDisabled = eduDate.some((range: any) =>
                    e.target.value >= range.min && e.target.value <= range.max
                );

                if (isDisabled) {
                    eduFormik.setFieldValue("start_date", '')
                    setDateFromErr(true)
                } else {
                    setDateFromErr(false)
                    eduFormik.setFieldValue("start_date", e.target.value)
                }
            }
        } else {
            setDateFromErr(false)
            eduFormik.setFieldValue("start_date", e.target.value)
        }

    }

    const handleEndDate = (e: any) => {
        if (eduDate?.length > 0) {
            if ((!!editEdu || editEdu === 0)) {
                let arr: any[] = eduDate?.filter((i: any, idx: number) => idx !== editEdu)

                if (arr?.length > 0) {
                    const isDisabled = arr.some((range: any) =>
                        e.target.value >= range.min && e.target.value <= range.max
                    );

                    if (isDisabled) {
                        eduFormik.setFieldValue("end_date", '')
                        setDateToErr(true)
                    } else {
                        setDateToErr(false)
                        eduFormik.setFieldValue("end_date", e.target.value)
                    }
                } else {
                    setDateToErr(false)
                    eduFormik.setFieldValue("end_date", e.target.value)
                }
            } else {
                const isDisabled = eduDate.some((range: any) =>
                    e.target.value >= range.min && e.target.value <= range.max
                );

                if (isDisabled) {
                    eduFormik.setFieldValue("end_date", '')
                    setDateToErr(true)
                } else {
                    setDateToErr(false)
                    eduFormik.setFieldValue("end_date", e.target.value)
                }
            }
        } else {
            setDateToErr(false)
            eduFormik.setFieldValue("end_date", e.target.value)
        }
    }

    return (
        <div className="border border-[#E5E5E5] bg-[#FCFCFC] dark:bg-[#2e3037] dark:border-[#454545] py-[15px] px-[20px] xlx:py-[22px] xlx:px-[27px] flex flex-col gap-[15px] xsm:gap-[20px] xlx:gap-[25px]">
            <div className="flex flex-col gap-[4px]">
                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.standard_id")}*`}</h6>
                <SelectSecondaryComponent
                    options={qualificationList}
                    name="standard_id"
                    placeholder={t("recruitment.profile.placehoder.standard_id")}
                    isSearchable={false}
                    arrow={true}
                    components={{ DropdownIndicator }}
                    onChange={(e: any) => { eduFormik.setFieldValue("standard_id", e); }}
                    onBlur={(e: any) => eduFormik.setFieldTouched("standard_id", e)}
                    value={!!eduFormik.values.standard_id ? qualificationList?.find((item: any) => item?.value === eduFormik.values.standard_id?.value) : eduFormik.values.standard_id}
                />
                {eduFormik?.touched?.standard_id && eduFormik?.errors?.standard_id && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.standard_id}</span>
                </div>}
            </div>


            <div className="flex flex-col gap-[4px]">
                <PrimaryInput title={`${t("recruitment.profile.field.specialization_name")}*`} placeholder={t("recruitment.profile.placehoder.specialization_name")} name="specialization_name" value={eduFormik?.values?.specialization_name} onBlur={eduFormik?.handleBlur} onChange={eduFormik?.handleChange} />
                {eduFormik?.touched?.specialization_name && eduFormik?.errors?.specialization_name && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.specialization_name}</span>
                </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
                <PrimaryInput title={`${t("recruitment.profile.field.institute_name")}*`} placeholder={t("recruitment.profile.placehoder.institute_name")} type="text" name="institute_name" value={eduFormik?.values?.institute_name} onBlur={eduFormik?.handleBlur} onChange={eduFormik?.handleChange} />
                {eduFormik?.touched?.institute_name && eduFormik?.errors?.institute_name && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.institute_name}</span>
                </div>}
            </div>


            <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.profile.field.board_name")}*`} placeholder={t("recruitment.profile.placehoder.board_name")} type="text" name="board_name" value={eduFormik?.values?.board_name} onBlur={eduFormik?.handleBlur} onChange={eduFormik?.handleChange} />
                    {eduFormik?.touched?.board_name && eduFormik?.errors?.board_name && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.board_name}</span>
                    </div>}
                </div>

                <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.profile.field.per_cgpa")}*`} name="per_cgpa" type="number" exceptThisSymbols={["e", "E", "+", "-"]} placeholder={t("recruitment.profile.field.per_cgpa")} value={eduFormik?.values?.per_cgpa} onBlur={eduFormik?.handleBlur} onChange={eduFormik?.handleChange} />
                    {eduFormik?.touched?.per_cgpa && eduFormik?.errors?.per_cgpa && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.per_cgpa}</span>
                    </div>}
                </div>

                <div className="flex flex-col gap-[4px]">
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.result")}*`}</h6>
                    <SelectSecondaryComponent
                        options={results}
                        name="result"
                        placeholder={t("recruitment.profile.placehoder.result")}
                        isSearchable={false}
                        arrow={true}
                        components={{ DropdownIndicator }}
                        onChange={(e: any) => { eduFormik.setFieldValue("result", e); }}
                        onBlur={(e: any) => eduFormik.setFieldTouched("result", e)}
                        value={!!eduFormik.values.result ? results?.find((item: any) => item?.value === eduFormik.values.result?.value) : eduFormik.values.result}
                    />
                    {eduFormik?.touched?.result && eduFormik?.errors?.result && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.result}</span>
                    </div>}
                </div>

                <div className="flex flex-col gap-[4px]">
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.mode")}*`}</h6>
                    <SelectSecondaryComponent
                        options={modes}
                        name="mode"
                        placeholder={t("recruitment.profile.placehoder.mode")}
                        isSearchable={false}
                        arrow={true}
                        components={{ DropdownIndicator }}
                        onChange={(e: any) => { eduFormik.setFieldValue("mode", e); }}
                        onBlur={(e: any) => eduFormik.setFieldTouched("mode", e)}
                        value={!!eduFormik.values.mode ? modes?.find((item: any) => item?.value === eduFormik.values.mode?.value) : eduFormik.values.mode}
                    />
                    {eduFormik?.touched?.mode && eduFormik?.errors?.mode && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.mode}</span>
                    </div>}
                </div>
            </div>

            <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.profile.field.start_date")}*`} name="start_date" type="date" placeholder={t("recruitment.profile.field.start_date")} value={eduFormik?.values?.start_date} onBlur={eduFormik?.handleBlur} onChange={(e: any) => handleStartDate(e)} max={!!eduFormik?.values?.end_date ? new Date(eduFormik?.values?.end_date).toISOString().split("T")[0] : new Date().toISOString().split("T")[0]} />
                    {(eduFormik?.touched?.start_date && eduFormik?.errors?.start_date && !dateFromErr) && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.start_date}</span>
                    </div>}
                    {dateFromErr && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.valid_date")}</span>
                    </div>}
                </div>

                <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.profile.field.end_date")}*`} name="end_date" type="date" placeholder={t("recruitment.profile.field.end_date")} value={eduFormik?.values?.end_date} onBlur={eduFormik?.handleBlur} onChange={(e: any) => handleEndDate(e)} max={new Date().toISOString().split("T")[0]} min={!!eduFormik?.values?.start_date && new Date(eduFormik?.values?.start_date).toISOString().split("T")[0]} />
                    {(eduFormik?.touched?.end_date && eduFormik?.errors?.end_date && !dateToErr) && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{eduFormik?.errors?.end_date}</span>
                    </div>}
                    {dateToErr && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.valid_date")}</span>
                    </div>}
                </div>
            </div>

            <div className="flex items-end justify-end w-full">
                <SecondaryBtn title={t("recruitment.hr.create_ad.field.save")} css="px-[24px] font-semibold rounded-[6px] text-sm leading-snug !h-[35px]" onClick={eduFormik?.handleSubmit} />
            </div>
        </div>
    );
};

export default Educations;